angular.module('rjmNg.directives').directive 'renderTable', [
  "dateService"
  "figureService"
  "htmlTableService"
  "reportQueryType"
  "colorThemeService"
  (
    dateService
    figureService
    htmlTableService
    reportQueryType
    colorThemeService
  ) ->
    restrict: "E"
    templateUrl: 'directive.renderTable.html'
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      displayExporter: "="
      allowFreezeColumns: "="
      showColorMarkers: "=?"
    priority: 300
    controller: [
      "$scope"
      (
        $scope
      ) ->
        view = @

        view.resizeFunction = (width, height) ->
          $scope.$broadcast "resizeDataTable", width, height

        view.$onInit = () ->
          view.showColorMarkers ?= false
          view.displayExporter ?= false

        view
    ]
    link: (scope, elem, attrs, view) ->

      # figure directive is only to enforce directive structure, not to
      # use any figure directive controller functions.
      _transposeArray = (a) ->
        return Object.keys(a[0]).map (c) -> return a.map (r) -> return r[c]

      # Columns can have various options set
      _getColumnDefs = (colsToLeftAlign, dateCols) ->
        columnDefs = []

        columnDefs.push { sType: "rjmdate", aTargets: dateCols }
        # Left aligns certain columns
        columnDefs.push { sClass: "dimensionItem", aTargets: colsToLeftAlign, sType: 'auto' }
        # Use strippedNumerics sort logic for all other columns
        columnDefs.push { sType: "strippedNumerics", aTargets: ['_all'] }

        return columnDefs

      _getHeaderForSQLTable = (header) ->
        html = '<thead><tr>'
        for item in header
          html += "<th>#{item}</th>"
        html += '</tr></thead>'

      # Builds HTML <thead> element
      _getHeaderForRJQLTable = (reportHeaders, colsToLeftAlign) ->
        fullHeaderHtml = ''

        for row, rowIndex in reportHeaders
          headerHtml = ""
          colspan = 1

          for item, index in row
            if index in colsToLeftAlign
              optionalLeftAlignClass = 'class=\"dimensionItem\"'
            else
              optionalLeftAlignClass = ''

            # We want date headers to span multiple columns,
            # so look ahead to see if we have matches
            if row[index] is row[index+1] and rowIndex is 0
              colspan += 1
            else
              # If we create the th element, reset our colspan count
              headerHtml += "<th colspan=\"#{colspan}\" #{optionalLeftAlignClass}>#{item}</th>"
              colspan = 1
          headerHtml = "<tr>#{headerHtml}</tr>"
          fullHeaderHtml += headerHtml

        return "<thead>" + fullHeaderHtml + "</thead>"

      _getDTOptionsFromSQLFigure = (figure) ->
        data: figure.data.body
        headerHtml: _getHeaderForSQLTable(figure.data.header)
        columnDefs: _getColumnDefs([], [])
        id: figure.id
        numLeftColsToFreeze: 0
        freezeColumns: false
        displayExporter: view.displayExporter

      _getDTOptionsFromRJQLFigure = (figure, tableOrderIndex=0) ->
        isCohortFigure = figureService.isCohortFigure(figure)
        isTimeBasedCohortFigure = figureService.isTimeBasedCohortFigure(figure)

        # We need the time interval for formatting any place where we might be displaying dates
        timeInterval = figureService.getTimeInterval(figure)

        figureDimensions = figureService.getDimensionsFromFigure(figure)
        dimensions = figureDimensions[0]
        dimensions ?= []

        # We use different default viewing styles if we have groups
        viewType = if figureService.isGroupedByDimension(figure) then 'dimensionView' else 'normalView'

        # This the the main data for our table and includes everything except headers
        report = htmlTableService.generateTableFromFigureData(figure.data, figure.query.select.measures, timeInterval, viewType, [])

        # If the figure is cohort then we have to format row names
        if isCohortFigure
          for row, index in report
            indexWithShift = (tableOrderIndex * report.length) + index
            color = colorThemeService.pickColor(indexWithShift)
            prefix = if view.showColorMarkers then "<div class='report-builder__table-marker' style='background-color:#{color}'></div>" else ""
            row[0] = prefix + if isTimeBasedCohortFigure then dateService.shortFormat(row[0], timeInterval, true) else row[0]

        # Add headers to the report
        headers = htmlTableService.generateHeadersFromFigure(figure, viewType, timeInterval, isCohortFigure, isTimeBasedCohortFigure)
        headerRowCount = headers.length

        # Using concat here, because we actually return a 2D array
        # so we can support multiple header rows
        report = headers.concat(report)

        # We transpose the data with the headers in it, so only have to build them one way
        if figure.presentation.table.transpose
          report = _transposeArray(report)
          # transposed tables should only have one header row (usually the dimension names)
          headerRowCount = if dimensions.length > 1 then dimensions.length else 1

        # Get back our header rows, which may be different now if we've transposed
        reportHeaders = report.splice(0,headerRowCount)
        # Blow up any table we might have here

        # the first two columns should have the 'dimensionItem' left alignment class applied
        # if the following conditions are met, othwerwise only first col is left aligned
        colsToLeftAlign = []
        if viewType is 'dimensionView'
          if timeInterval isnt 'None'
            colsToLeftAlign = [0..dimensions.length-1]
          else
            colsToLeftAlign = [0..dimensions.length-1]
        else
          colsToLeftAlign = [0]

        dateCols = []
        if timeInterval isnt 'None' and
          (figure.presentation.table.transpose and viewType is 'dimensionView' and not isCohortFigure) or
          (not figure.presentation.table.transpose and viewType isnt 'dimensionView') or
          (not figure.presentation.table.transpose and isCohortFigure)
            dateCols = [0]

        shouldFreezeColumns = view.allowFreezeColumns and
          figure.presentation.table.freezeColumns and
          dimensions.length > 0 and
          timeInterval isnt 'None'

        data: report
        headerHtml: _getHeaderForRJQLTable(reportHeaders, colsToLeftAlign)
        columnDefs: _getColumnDefs(colsToLeftAlign, dateCols)
        id: figure.id
        numLeftColsToFreeze: colsToLeftAlign.length
        freezeColumns: shouldFreezeColumns
        displayExporter: view.displayExporter

      scope.$on "renderFigure", (event, figure) ->
        if figure.reportQueryType is reportQueryType.RJQL
          view.DTOptions = []
          for dividedFigure, index in figureService.splitFigureIfNecessary(figure)
            view.DTOptions.push(_getDTOptionsFromRJQLFigure(dividedFigure, index))
        else
          view.DTOptions = [_getDTOptionsFromSQLFigure(figure)]
]
